import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { SubTasksBaseDataProvider } from '../dataProvider/SubTasksBaseDataProvider';

export class SubTasksDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, SubTasksBaseDataProvider);
  }
}
